module.exports = __webpack_public_path__ + "static/media/aboutus.e32c2af4.jpg";